import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "progressContainer",
    "progressBar",
    "progressText",
    "errorSummary",
    "errorList"
  ]

  static values = {
    runId: Number,
    statusUrl: String,
    status: String,
    pollInterval: { type: Number, default: 2000 }
  }

  connect() {
    if (!this.runIdValue || !this.statusUrlValue) return

    if (this.statusValue === "completed" || this.statusValue === "failed") {
      return
    }

    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.stopPolling()
    this.pollTimer = setInterval(() => this.checkStatus(), this.pollIntervalValue)
    this.checkStatus()
  }

  stopPolling() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer)
      this.pollTimer = null
    }
  }

  async checkStatus() {
    try {
      const response = await fetch(this.statusUrlValue, { headers: { Accept: "application/json" } })
      const data = await response.json()

      this.updateProgress(data)
      this.updateErrors(data.errors)

      if (data.status === "completed" || data.status === "failed") {
        this.stopPolling()
        // Reload to show the final table/results
        window.location.reload()
      }
    } catch (e) {
      // Stop polling on repeated errors to avoid hammering
      this.stopPolling()
    }
  }

  updateProgress(data) {
    if (!this.hasProgressContainerTarget) return

    this.progressContainerTarget.classList.remove("hidden")

    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${data.progress || 0}%`
    }

    if (this.hasProgressTextTarget) {
      const total = data.total_rows || 0
      const processed = data.processed_rows || 0
      if (total > 0) {
        this.progressTextTarget.textContent = `Procesando ${processed} de ${total} registros...`
      } else {
        this.progressTextTarget.textContent = "Preparando importación..."
      }
    }
  }

  updateErrors(errors) {
    if (!this.hasErrorSummaryTarget || !this.hasErrorListTarget) return

    if (!errors || errors.length === 0) {
      this.errorSummaryTarget.classList.add("hidden")
      return
    }

    this.errorSummaryTarget.classList.remove("hidden")
    this.errorListTarget.innerHTML = errors
      .slice(0, 200)
      .map(
        (error) => `
          <li class="import-error">
            <span class="import-error__row">Fila ${error.row}:</span>
            <span class="import-error__field">${error.field}</span>
            <span class="import-error__message">${error.message}</span>
          </li>
        `
      )
      .join("")
  }
}
